import { Component, OnInit } from '@angular/core';
import { KeyDropLocationService } from '../../../business-services/dealer-keyDrop-location.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { KeyDropLocationViewModel } from '../../../business-entities/dealer-keydrop-location-view-model';
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-dealer-keydrop-location',
  templateUrl: './add-dealer-keydrop-location.component.html'
})
export class AddDealerKeydropLocationComponent implements OnInit {
  locationList: SelectListItemViewModel[];
  dealerList: Array<SelectListItemViewModel>;
  keyDropLocationViewModel: KeyDropLocationViewModel;
  selectedDealerId: string = '';
  constructor(public service: KeyDropLocationService,
    public dealerBusinessService: DealerBusinessService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private activeModal : NgbActiveModal) {
    this.keyDropLocationViewModel = {
      id: 0,
      dealerId: '',
      locationName: '',
      locationType: 0,
      locationTypeName: '',
      isActive: true,
      isDeleted: true,
      createdBy: 0,
      createdDate: new Date(),
      updatedBy: 0,
      updatedDate: new Date(),
      dealerName: ''
    }
  }

  ngOnInit(): void {
    this.getLocationList();
    this.dealerList = this.service.dealerList;
    this.checkId();
  }
  OnClose(){
    this.activeModal.close({success:false})
  }
  async getLocationList() {
    await this.service.getLocationList().then((response) => {
      this.locationList = response.responseObject;
    });
  }

  checkId(){
    if(this.service.dealerId){
      this.service.isEdit = true;
      this.selectedDealerId = this.service.dealerId
    }
  }

  Add(model: KeyDropLocationViewModel) {
    let successMessage = this.translate.instant("lblAddSuccessfully");
    let errorMessage = this.translate.instant("lblErrorMessage");
    model.dealerId = this.selectedDealerId;
    this.service.addKeyDropLocation(model).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
       this.activeModal.close({ success: true
       });
        this.toaster.success(successMessage);
      }
      else
        this.toaster.error(errorMessage);
    })
  }

  getValue(locationTypeName: string) {
    this.keyDropLocationViewModel.locationType = parseInt(this.locationList.find(x => x.value == locationTypeName).value);
  }

}
